import React, { useState, useEffect } from "react"
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import { connect, useDispatch, useSelector } from 'react-redux';
import axios from "axios";
import * as url from "../../api/uri_helper";
// Import static images 
import logo from "../../UserAssets/images/authenteklogo.png"
import TEkaHelp from "../../assets/images/TEkaHelp.svg";
import LeftArrow from "../../assets/images/leftArrow.svg";
import favIcon from "../../assets/images/fav.ico"
import { getCompnaysitedata } from "../../Redux/Actions/DashboardCount";

const Header = ({ handleClose, handleOpen, isSideBaropen }) => {
    const dispatch = useDispatch();
    const allCompanysitedata = useSelector((state) => state.allDashboardReducer.companysite); // data
    const comingsiteId = localStorage.getItem('SiteId');
    const companyId = localStorage.getItem('ComingTekaverse');
    const [resellercompanyLogo, setResellerCompanyLogo] = useState('');
    const [companyLogo, setCompanyLogo] = useState('');
    //  const CompanyLogo = allCompanysitedata && allCompanysitedata.companyLogo;
    // const ResellerCompanyLogo = allCompanysitedata && allCompanysitedata.resellerCompanyLogo;

    useEffect(() => {
        GetCompanyAndSiteData();
    }, [])

    const GetCompanyAndSiteData = async () => {

        const response = await axios
            .post(url.POST_COMPANYSITEDATABYID,
                {
                    CompanyId: companyId,
                    SiteId: comingsiteId

                })
            .then(response => {

                if (response && response.data) {
                    dispatch(getCompnaysitedata(response.data));


                    if (response.data.data && response.data.data.companyLogo) {
                        setCompanyLogo(response.data.data.companyLogo);
                    } else {
                        setCompanyLogo(null);
                    }

                    if (response.data.data && response.data.data.resellerCompanyLogo) {
                        setResellerCompanyLogo(response.data.data.resellerCompanyLogo);
                    } else {
                        setResellerCompanyLogo(null);
                    }
                }
            })
    }


    return (
        <div className="dash-log">
            <NavbarBrand tag={Link} to="/Dashboard">
                <div className="d-flex flex-column align-items-center">
                    <img className='logo-large mb-3' src={companyLogo}></img>
                    <img className='logo-large' src={resellercompanyLogo}></img>
                    <img className='logo-small' src={favIcon}></img>

                </div>
            </NavbarBrand>

            <button className="hamburger" onClick={() => handleOpen()} >
                <img src={LeftArrow}></img>
            </button>

            <button className={["hamburger-rotate", isSideBaropen ? "active" : ""].join(" ")} onClick={() => handleClose()}>
                <img src={LeftArrow}></img>
            </button>
        </div>
    )
}

export default Header
